import { render } from "./Hot.vue?vue&type=template&id=17b0cdc4&scoped=true"
import script from "./Hot.vue?vue&type=script&lang=ts"
export * from "./Hot.vue?vue&type=script&lang=ts"

import "./Hot.vue?vue&type=style&index=0&id=17b0cdc4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-17b0cdc4"

export default script